import { Injectable, signal } from '@angular/core';

/**
 * When set, the group-order shell renders {@link SomethingWentWrongComponent} instead of the router-outlet.
 * Used for recoverable API failures and as the target for the v3-scoped {@link GroupOrderErrorHandler}.
 */
@Injectable({ providedIn: 'root' })
export class GroupOrderFatalErrorService {
  readonly fatalError = signal(false);

  reportFatalError(): void {
    this.fatalError.set(true);
  }

  clear(): void {
    this.fatalError.set(false);
  }
}
